// extracted by mini-css-extract-plugin
export default {"AlertDialogButton":"alertDialogButton_AlertDialogButton__nVHmh","red":"alertDialogButton_red__mr2GB","blue":"alertDialogButton_blue__26-Cr","black":"alertDialogButton_black__UpdAp"};